export default function () {
    return {
        brandData: {
            fontNamePrimary: "Inter",
            displayName: "Turnr",
            homePage: "https://www.ingrid.com/",
            fontSizePrimary: 12,
            colorPrimary: "#57251b",
            colorSecondary: "#e0d4c5",
            orderIdPrefix: "#",
            orderIdText: "ORDER_ID",
            backgroundImage: "https://wallpaperaccess.com/full/552581.jpg",
            backgroundImageOpacity: 65,
            backgroundImageBlur: 2,
            logoSrc: "/icons/ingrid/logo-ingrid-black.svg",
            logoHeight: 30,
            productsBundleMock: "DEV_ALL_ORDERS_BRAND",
            exchangeActive: true,
            showAllOrders: true,
        },
        brandName: "dev-all-orders-brand",
    };
}
